export default __webpack_public_path__ + "static/media/piekea-home.6295d14e.gif";